<div class="stepper-actions-container">
  <button (click)="moveToLibrary()" class="back-button">
    <img
      style="margin-right: 1vw; width: 1vw"
      src="../../assets/back.svg"
      alt="back"
    />Go Back
  </button>
</div>
<div id="planogram-library-container">
  <div class="custom_planogram_library_header">
    <div class="header">
      <em
        class="bi bi-person"
        style="font-size: 1.3rem; margin-right: 0.6vw"
      ></em>
      Admin
    </div>
    <div class="view-edit-text">
      <div>Edit Mode</div>
    </div>
    <div
      style="width: 62%; font-size: 1.2vw; font-weight: 600; text-align: center"
    >
      Custom Planogram Library
    </div>
  </div>
  <div class="library">
    <div *ngFor="let planogram of library_data">
      <div class="planogram-card">
        <img *ngIf="planogram.imageUrl" style="height: 200px" [src]="planogram.imageUrl" />
        <div
          style="
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            padding-left: 15px;
          "
        >
          <table class="planogram_details_table">
            <thead>
              <tr>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Name:</td>
                <td
                  *ngIf="planogram.name.length > 12"
                  [matTooltip]="planogram.name"
                >
                  {{ planogram.name.slice(0, 12) }}...
                </td>
                <td *ngIf="planogram.name.length <= 12">
                  {{ planogram.name }}
                </td>
              </tr>
              <tr>
                <td>Unit:</td>
                <td>{{ planogram.unit }}</td>
              </tr>
              <tr>
                <td>Channel:</td>
                <td>{{ planogram.channel }}</td>
              </tr>
              <tr>
                <td>Cooler:</td>
                <td>{{ planogram.cooler_type }}</td>
              </tr>
              <tr>
                <td>Created On:</td>
                <td>{{ planogram.created_at }}</td>
              </tr>
            </tbody>
          </table>
          <div class="button-container">
            <button (click)="editPlanogram(planogram.id)" class="my-red-button">
              Edit</button
            ><button
              (click)="handleDeleteClick($event, planogram.id)"
              class="my-clear-button delete"
            >
              Delete
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-loader [is_show_loader]="(is_show_loader | async)!"></app-loader>
</div>
